import { Theme } from '@emotion/react';

const font: Theme['font'] = {
	families: {
		primary: {
			default: "'LandRoverWeb-Medium', Arial, Helvetica, sans-serif",
			bold: "'LandRoverWeb-Bold', Arial, Helvetica, sans-serif",
			demi: "'LandRoverWeb-Demi', Arial, Helvetica, sans-serif",
			light: "'LandRoverWeb-Light', Arial, Helvetica, sans-serif",
		},
		secondary: {
			default: "'AvenirNext', Arial, Helvetica, sans-serif",
			bold: "'AvenirNext', Arial, Helvetica, sans-serif",
			demiBold: "'AvenirNext', Arial, Helvetica, sans-serif",
			medium: "'AvenirNext', Arial, Helvetica, sans-serif",
			italic: "'AvenirNext', Arial, Helvetica, sans-serif",
		},
		tertiary: {
			default: "'ascender', Arial, Helvetica, sans-serif",
			bold: "'ascender-bold', Arial, Helvetica, sans-serif",
			boldItalic: "'ascender-bold-italic', Arial, Helvetica, sans-serif",
			italic: "'ascender-italic', Arial, Helvetica, sans-serif",
		},
		icon: "'icons-2022', 'icons-dx'",
	},
	base: {
		size: 10,
		height: 1.5,
		weight: 'normal',
	},
};

export default font;
